/**
 * 动态词汇的语言、状态展示文案和标签颜色（antd 预设色名）
 */
import { LANGUAGE_COLORS, STATUS_CONFIG, SUPPORTED_LANGUAGES } from '@/types/dynamic-lexemes'

export function languageColor(language: string) {
  return LANGUAGE_COLORS[language as keyof typeof LANGUAGE_COLORS] ?? 'default'
}

export function languageName(language: string) {
  return SUPPORTED_LANGUAGES[language as keyof typeof SUPPORTED_LANGUAGES] ?? language.toUpperCase()
}

export function lexemeStatusColor(status: string) {
  return STATUS_CONFIG[status as keyof typeof STATUS_CONFIG]?.color ?? 'default'
}

export function lexemeStatusText(status: string) {
  return STATUS_CONFIG[status as keyof typeof STATUS_CONFIG]?.label ?? status
}
